const handleDeleteCompanyFailformCampany = {
  title: 'NO SE PUEDE ELIMINAR ESTE DOCUMENTO'
};

export default handleDeleteCompanyFailformCampany;
